import React, { useEffect, useState } from "react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import DatePopUp from "./date_popup.js";
import TaskPopUp from "./task_popup.js";
import { CSVLink } from "react-csv";
import "../styles/search_popup.css";
import { downloadExcel } from "react-export-table-to-excel";
import { secretKey } from "../.././data";
import Loading from "../helpers/loading_component.js";

const MySwal = withReactContent(Swal2);

const ReportPopUp = (props) => {
  const [works, setWorks] = useState([]);
  const [hearings, setHearings] = useState([]);
  const [showDate, setShowDate] = useState(false);
  const [dateId, setDateId] = useState("");
  const [showTask, setShowTask] = useState(false);
  const [taskId, setTaskId] = useState("");
  const [search, setSearch] = useState("");
  const [sygn, setSygn] = useState("");
  const [bank, setBank] = useState("");
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [taskType, setTaskType] = useState("");
  const [hearingResult, setHearingResult] = useState("");
  const [hearingSubject, setHearingSubject] = useState("");
  const [employe, setEmploye] = useState("");
  const [hearingsCSVData, setHearingsCSVData] = useState([]);
  const [tasksCSVData, setTasksCSVData] = useState([]);
  const [hearingsData, setHearingsData] = useState([]);
  const [tasksData, setTasksData] = useState([]);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchHearings = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getHearings", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setHearingsData(
          data.filter((el) =>
            props.user.archSpraw === "1" ? true : el.arch === "0"
          )
        );
      })
      .catch((error) => {});
  };

  const fetchTasks = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getTasks", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setTasksData(
          data.filter((el) =>
            props.user.archSpraw === "1" ? true : el.arch === "0"
          )
        );
        fetchResults();
      })
      .catch((error) => {});
  };

  const fetchResults = async () => {
    var body = {
      team: props.team,
    };

    await fetch("https://apidevkppp.ftpeople.pl/getExpectedResults", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: secretKey,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        setResults(data);
        setLoading(false);
      })
      .catch((error) => {});
  };

  useEffect(() => {
    setLoading(true);
    fetchHearings();
    fetchTasks();
  }, []);

  const closeDatePopUp = (e) => {
    setShowDate(!showDate);
    setDateId("");
  };

  const showDatePopUp = (e) => {
    setDateId(e.target.value);
    setShowDate(true);
    setShowTask(false);
  };

  const closeTaskPopUp = (e) => {
    setShowTask(!showTask);
  };

  const clearData = (e) => {
    setSearch("");
    setSygn("");
    setBank("");
    setDateFrom("");
    setDateTo("");
    setEmploye("");
    setTaskType("");
    setHearingResult("");
    setHearingSubject("");
    searchData("", "", "");
  };

  const showTaskPopUp = (e) => {
    setTaskId(e.target.value);
    setShowTask(true);
    setShowDate(false);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleDateFromChange = (e) => {
    setDateFrom(e.target.value);
  };

  const handleDateToChange = (e) => {
    setDateTo(e.target.value);
  };

  const handleSygnChange = (e) => {
    setSygn(e.target.value);
  };

  const handleBankChange = (e) => {
    setBank(e.target.value);
  };

  const handleTaskTypeChange = (e) => {
    setTaskType(e.target.value);
  };

  const handleHearingResultChange = (e) => {
    setHearingResult(e.target.value);
  };

  const handleHearingSubjectChange = (e) => {
    setHearingSubject(e.target.value);
  };

  const handleEmployeChange = (e) => {
    setEmploye(e.target.value);
  };

  const searchData = (nameA, sygnA, bankA) => {
    if (
      nameA.length === 0 &&
      sygnA.length === 0 &&
      bankA.length === 0 &&
      dateFrom.length === 0 &&
      dateTo.length === 0 &&
      employe.length === 0 &&
      taskType.length === 0 &&
      hearingResult.length === 0 &&
      hearingSubject.length === 0
    ) {
      setWorks([]);
      setHearings([]);
    } else {
      var newHearingsArray = hearingsData;
      var newTasksArray = tasksData;

      if (search.length > 0) {
        newHearingsArray = newHearingsArray.filter((el) =>
          el.name
            .toString()
            .toLowerCase()
            .includes(search.toString().toLowerCase())
        );
        newTasksArray = newTasksArray.filter((el) =>
          el.client_name
            .toString()
            .toLowerCase()
            .includes(search.toString().toLowerCase())
        );
      }
      if (sygn.length > 0) {
        newHearingsArray = newHearingsArray.filter((el) =>
          el.sygn
            .toString()
            .toLowerCase()
            .replaceAll(" ", "")
            .includes(sygn.toString().toLowerCase().replaceAll(" ", ""))
        );
        newTasksArray = newTasksArray.filter((el) =>
          el.sygn
            .toString()
            .toLowerCase()
            .replaceAll(" ", "")
            .includes(sygn.toString().toLowerCase().replaceAll(" ", ""))
        );
      }

      if (bank.length > 0) {
        newHearingsArray = newHearingsArray.filter((el) => el.bank === bank);
        newTasksArray = newTasksArray.filter((el) => el.bank === bank);
      }

      if (dateFrom.length > 0 && dateTo.length > 0) {
        newHearingsArray = newHearingsArray.filter(
          (el) =>
            new Date(el.date) >= new Date(dateFrom) &&
            new Date(el.date) <= new Date(dateTo)
        );
        newTasksArray = newTasksArray.filter(
          (el) =>
            new Date(el.final_date) >= new Date(dateFrom) &&
            new Date(el.final_date) <= new Date(dateTo)
        );
      }

      if (hearingResult.length > 0) {
        newHearingsArray = newHearingsArray.filter(
          (el) => el.result === hearingResult
        );
      }

      if (hearingSubject.length > 0) {
        newHearingsArray = newHearingsArray.filter(
          (el) => el.subject === hearingSubject
        );
      }

      if (employe.length > 0) {
        newHearingsArray = newHearingsArray.filter(
          (el) => el.lawyer === employe
        );
        newTasksArray = newTasksArray.filter(
          (el) => el.responsible === employe
        );
      }

      if (taskType.length > 0) {
        newTasksArray = newTasksArray.filter((el) => el.task === taskType);
      }

      if (
        nameA.length === 0 &&
        sygnA.length === 0 &&
        bankA.length === 0 &&
        employe.length === 0 &&
        taskType.length > 0 &&
        hearingResult.length === 0 &&
        hearingSubject.length === 0
      ) {
        newHearingsArray = [];
      }

      if (
        nameA.length === 0 &&
        sygnA.length === 0 &&
        bankA.length === 0 &&
        employe.length === 0 &&
        taskType.length === 0 &&
        (hearingResult.length > 0 || hearingSubject.length > 0)
      ) {
        newTasksArray = [];
      }

      setHearings(newHearingsArray);
      setWorks(newTasksArray);
      generateHearingsCSVData(newHearingsArray);
      generateTasksCSVData(newTasksArray);
    }
  };

  const generateHearingsCSVData = (dataH) => {
    var dataArr = [];
    var data = "";
    dataH.map((el) => {
      var row = [
        el.id,
        el.name,
        el.date,
        el.time,
        el.court,
        el.bank,
        el.sygn,
        el.wps,
        el.form,
        el.online_url,
        el.subject,
        el.lawyer,
        el.lawyer_form,
        el.substitute_name,
        el.guardian_name,
        el.result,
        el.result_type,
        el.result_note,
        el.note,
        el.date_added,
        el.user_added,
        el.accepted,
        el.status,
      ];
      dataArr.push(row);
    });

    var dataText = "";
    dataText = dataArr.map((data) => {
      dataText = dataText + "[" + data + "],";
    });

    var i = 0;
    data = [
      [
        "ID",
        "Imię i nazwisko",
        "Data rozprawy",
        "Godzina rozprawy",
        "Sąd",
        "Bank",
        "Sygnatura",
        "WPS",
        "Rodzaj rozprawy",
        "Link do rozprawy",
        "Temat rozprawy",
        "Prawnik",
        "Forma reprezentacji",
        "Imię i nazwisko substytuta",
        "Imię i nazwisko opiekuna",
        "Wynik rozprawy",
        "Rodzaj wyniku rozprawy",
        "Notatka do rozprawy",
        "Notatka",
        "Data dodania",
        "Uzytkownik",
        "Zaakceptowano",
        "Status",
      ],
    ];
    dataArr.map((dataEl) => {
      data.push(dataEl);
    });

    setHearingsCSVData(data);
  };

  const generateTasksCSVData = (dataH) => {
    var dataArr = [];
    var data = "";
    dataH.map((el) => {
      var row = [
        el.id,
        el.start_date,
        el.client_name,
        el.bank,
        el.sygn,
        el.task,
        el.final_date,
        el.responsible,
        el.date_added,
        el.user_added,
        el.status,
      ];
      dataArr.push(row);
    });

    var dataText = "";
    dataText = dataArr.map((data) => {
      dataText = dataText + "[" + data + "],";
    });

    var i = 0;
    data = [
      [
        "ID",
        "Data rozpoczęcia",
        "Imię i nazwisko",
        "Bank",
        "Sygnatura",
        "Zadanie",
        "Termin wykonania",
        "Osoba odpowiedzialna",
        "Data dodania",
        "Uzytkownik",
        "Status",
      ],
    ];
    dataArr.map((dataEl) => {
      data.push(dataEl);
    });

    setTasksCSVData(data);
  };

  const generateReport = () => {
    searchData(search, sygn, bank);
    MySwal.fire({
      icon: "success",
      title: "Wygenerowano",
      text: "raport",
    });
  };

  const exportHearingExcel = (e) => {
    var header = [
      "ID",
      "Imię i nazwisko",
      "Data rozprawy",
      "Godzina rozprawy",
      "Sąd",
      "Bank",
      "Sygnatura",
      "WPS",
      "Rodzaj rozprawy",
      "Link do rozprawy",
      "Temat rozprawy",
      "Prawnik",
      "Forma reprezentacji",
      "Imię i nazwisko substytuta",
      "Imię i nazwisko opiekuna",
      "Wynik rozprawy",
      "Rodzaj wyniku rozprawy",
      "Notatka do rozprawy",
      "Notatka",
      "Data dodania",
      "Uzytkownik",
      "Zaakceptowano",
      "Status",
    ];
    downloadExcel({
      fileName: "hearings_report",
      sheet: "data",
      tablePayload: {
        header,
        // accept two different data structures
        body: hearings,
      },
    });
  };

  const exportTasksExcel = (e) => {
    var header = [
      "ID",
      "Data rozpoczęcia",
      "Imię i nazwisko",
      "Bank",
      "Sygnatura",
      "Zadanie",
      "Termin wykonania",
      "Osoba odpowiedzialna",
      "Data dodania",
      "Uzytkownik",
      "Status",
    ];
    downloadExcel({
      fileName: "tasks_report",
      sheet: "data",
      tablePayload: {
        header,
        // accept two different data structures
        body: works,
      },
    });
  };

  const getUsersForTeam = (e) => {
    var usersForTeam = [];

    props.users.map((el) => {
      if (el.team.split(",").filter((el2) => +el2 === props.team).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const getBanksForTeam = (e) => {
    var usersForTeam = [];

    props.banksData.map((el) => {
      if (el.team.split(",").filter((el2) => +el2 === props.team).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  const getTaskTypesForTeam = (e) => {
    var usersForTeam = [];

    props.tasksTypesData.map((el) => {
      if (el.team.split(", ").filter((el2) => +el2 === props.team).length > 0) {
        usersForTeam.push(el);
      }
    });

    return usersForTeam;
  };

  return (
    <>
      {showDate ? (
        <>
          <DatePopUp
            dateID={dateId}
            hearingsData={hearingsData}
            hearingsSheetData={props.hearingsSheetData}
            tasksData={props.tasksData}
            tasksSheetData={props.tasksSheetData}
            close={closeDatePopUp}
            lawyersData={props.lawyersData}
            refreshData={props.refreshData}
            user={props.user}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.usersData}
            resultsData={props.resultsData}
            tasksTypesData={props.tasksTypesData}
            history={props.history}
            checkPermissions={props.checkPermissions}
            substitutesData={props.substitutesData}
            team={props.team}
            hearingsTeam2Data={props.hearingsTeam2Data}
            hearingsTeam2SheetData={props.hearingsTeam2SheetData}
            tasksTeam2Data={props.tasksTeam2Data}
            tasksTeam2SheetData={props.tasksTeam2SheetData}
            archDateTeam2={props.archDateTeam2}
            archDate={props.archDate}
            filesData={props.filesData}
            logClientAction={props.logClientAction}
          />
        </>
      ) : (
        ""
      )}
      {showTask ? (
        <>
          <TaskPopUp
            taskID={taskId}
            hearingsData={hearingsData}
            tasksData={tasksData}
            tasksSheetData={props.tasksSheetData}
            closeTaskPopUp={closeTaskPopUp}
            lawyersData={props.lawyersData}
            refreshData={props.refreshData}
            user={props.user}
            courtsData={props.courtsData}
            banksData={props.banksData}
            usersData={props.usersData}
            resultsData={props.resultsData}
            tasksTypesData={props.tasksTypesData}
            history={props.history}
            checkPermissions={props.checkPermissions}
            team={props.team}
            hearingsTeam2Data={props.hearingsTeam2Data}
            hearingsTeam2SheetData={props.hearingsTeam2SheetData}
            tasksTeam2Data={props.tasksTeam2Data}
            tasksTeam2SheetData={props.tasksTeam2SheetData}
            archTasksTeam2={props.archTasksTeam2}
            archTasks={props.archTasks}
            filesData={props.filesData}
            logClientAction={props.logClientAction}
          />
        </>
      ) : (
        ""
      )}
      {showDate || showTask ? (
        ""
      ) : (
        <div className="mainContainerDatePopUp">
          {loading ? (
            <Loading id="popUpLoading" />
          ) : (
            <>
              <div className="mainContainerSearchPopUp">
                <div style={{ width: "100%" }} className="closeBox">
                  <button className="closeClientButton" onClick={props.close}>
                    X
                  </button>
                </div>

                <div className="inputBox_search">
                  <div className="inputCol_3">
                    <label className="lbSearch">Imię i nazwisko klienta</label>
                    <input
                      type="text"
                      id="search"
                      name="signature"
                      value={search}
                      onChange={handleSearchChange}
                    />
                  </div>
                  <div className="inputCol_3">
                    <label className="lbSearch">Sygnatura</label>
                    <input
                      type="text"
                      id="search"
                      name="signature"
                      value={sygn}
                      onChange={handleSygnChange}
                    />
                  </div>
                  <div className="inputCol_3">
                    <label className="lbSearch">Bank</label>
                    <select
                      type="text"
                      id="selReport"
                      name="court"
                      value={bank}
                      onChange={handleBankChange}
                    >
                      {bank === "" ? (
                        <option key="0" value="no">
                          Wybierz z listy...
                        </option>
                      ) : (
                        ""
                      )}
                      {getBanksForTeam().map((el) => (
                        <option key={el.name} value={el.name}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="inputBox_search">
                  <div className="inputCol_3">
                    <label className="lbSearch">Data od</label>
                    <input
                      type="date"
                      id="search"
                      name="signature"
                      value={dateFrom}
                      onChange={handleDateFromChange}
                    />
                  </div>
                  <div className="inputCol_3">
                    <label className="lbSearch">Data do</label>
                    <input
                      type="date"
                      id="search"
                      name="signature"
                      value={dateTo}
                      onChange={handleDateToChange}
                    />
                  </div>
                  <div className="inputCol_3">
                    <label className="lbSearch">Pracownik</label>
                    <select
                      type="text"
                      id="selReport"
                      name="signature"
                      value={employe}
                      onChange={handleEmployeChange}
                    >
                      <option key="0" value="">
                        Wszystkie
                      </option>
                      <option key="1" value="none">
                        Nieprzypisane
                      </option>
                      {getUsersForTeam().map((el) => (
                        <option key={el.name} value={el.name}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="inputBox_search">
                  <div className="inputCol_3">
                    <label className="lbSearch">Rodzaj zadania</label>
                    <select
                      id="selReport"
                      type="text"
                      name="court"
                      value={taskType}
                      onChange={handleTaskTypeChange}
                    >
                      <option key="0" value="">
                        Wszystkie
                      </option>
                      {getTaskTypesForTeam().map((el) => (
                        <option key={el.name} value={el.name}>
                          {el.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="inputCol_3">
                    <label className="lbSearch">Wynik rozprawy</label>
                    <select
                      id="selReport"
                      type="text"
                      name="court"
                      value={hearingResult}
                      onChange={handleHearingResultChange}
                    >
                      <option key="0" value="">
                        Wszystkie
                      </option>
                      {results.map((r) => (
                        <option key={r.name} value={r.name}>
                          {r.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="inputCol_3">
                    <label className="lbSearch">Przedmiot rozprawy</label>
                    <select
                      id="selReport"
                      type="text"
                      name="form"
                      value={hearingSubject}
                      onChange={handleHearingSubjectChange}
                    >
                      <option key="0" value="">
                        Wszystkie
                      </option>
                      <option key="1" value="Przesłuchanie strony">
                        Przesłuchanie strony
                      </option>
                      <option key="2" value="Przesłuchanie świadków">
                        Przesłuchanie świadków
                      </option>
                      <option key="3" value="Przesłuchanie strony i świadków">
                        Przesłuchanie strony i świadków
                      </option>
                      <option key="4" value="Apelacyjna">
                        Apelacyjna
                      </option>
                      <option key="5" value="Ogłoszenie wyroku">
                        Ogłoszenie wyroku
                      </option>
                      <option key="6" value="Inny">
                        Inny
                      </option>
                    </select>
                  </div>
                </div>
                <div className="inputBox_search">
                  <button
                    id="searchButton"
                    className="acceptButton"
                    onClick={generateReport}
                  >
                    WYGENERUJ
                  </button>
                  <button
                    id="searchButton"
                    className="acceptButton"
                    onClick={clearData}
                  >
                    WYCZYŚĆ
                  </button>
                  {hearings.length > 0 ? (
                    <button
                      id="searchButton"
                      className="acceptButton"
                      onClick={exportHearingExcel}
                    >
                      EXPORT ROZPRAW
                    </button>
                  ) : (
                    ""
                  )}
                  {works.length > 0 ? (
                    <button
                      id="searchButton"
                      className="acceptButton"
                      onClick={exportTasksExcel}
                    >
                      EXPORT ZADAŃ
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
              {works.length === 0 && hearings.length === 0 ? (
                <div className="hearingTitle">Nie znaleziono wyników!</div>
              ) : (
                <>
                  <div className="hearingTitle">Wyniki wyszukiwania:</div>
                  <div className="hearingTitleSub">
                    Ilość rozpraw: {hearings.length} | Ilość zadań:{" "}
                    {works.length}
                  </div>
                  {hearings.length > 0 ? (
                    <>
                      <div className="hearings_history_box">
                        <div className="hearings_history_title">ROZPRAWY</div>
                        <div className="hearings_data_box">
                          <div
                            id="hearings_data_header"
                            className="hearings_data_box_row"
                          >
                            <div className="hearings_data_box_col">
                              Data rozprawy
                            </div>
                            <div className="hearings_data_box_col">Klient</div>
                            <div className="hearings_data_box_col">
                              Sygnatura
                            </div>
                            <div className="hearings_data_box_col">Temat</div>
                            <div className="hearings_data_box_col"></div>
                          </div>
                          {hearings.map((el) => (
                            <>
                              <div className="hearings_data_box_row">
                                <div className="hearings_data_box_col">
                                  {el.date}
                                </div>
                                <div className="hearings_data_box_col">
                                  {el.name}
                                </div>
                                <div className="hearings_data_box_col">
                                  {el.sygn}
                                </div>
                                <div className="hearings_data_box_col">
                                  {el.subject}
                                </div>
                                <div className="hearings_data_box_col">
                                  <button
                                    className="viewButton"
                                    value={el.id}
                                    onClick={showDatePopUp}
                                  >
                                    PRZEJDŹ
                                  </button>
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                  {works.length > 0 ? (
                    <>
                      <div className="hearings_history_box">
                        <div className="hearings_history_title">ZADANIA</div>
                        <div className="hearings_data_box">
                          <div
                            id="hearings_data_header"
                            className="hearings_data_box_row"
                          >
                            <div className="hearings_data_box_col">
                              Termin wykonania
                            </div>
                            <div className="hearings_data_box_col">Klient</div>
                            <div className="hearings_data_box_col">Zadanie</div>
                            <div className="hearings_data_box_col">
                              Osoba odpowiedzialna
                            </div>
                            <div className="hearings_data_box_col"></div>
                          </div>
                          {works.map((el) => (
                            <>
                              <div className="hearings_data_box_row">
                                <div className="hearings_data_box_col">
                                  {el.final_date}
                                </div>
                                <div className="hearings_data_box_col">
                                  {el.client_name}
                                </div>
                                <div className="hearings_data_box_col">
                                  {el.task}
                                </div>
                                <div className="hearings_data_box_col">
                                  {el.responsible}
                                </div>
                                <div className="hearings_data_box_col">
                                  <button
                                    className="viewButton"
                                    value={el.id}
                                    onClick={showTaskPopUp}
                                  >
                                    PRZEJDŹ
                                  </button>
                                </div>
                              </div>
                            </>
                          ))}
                        </div>
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </>
              )}
            </>
          )}
        </div>
      )}
    </>
  );
};

export default ReportPopUp;
